// CheckoutDetails.tsx
import React, { useEffect, useState } from "react";
import OrderSummary from "./OrderSummary";
import CommonBanner from "../../../../components/common/banner/CommonBanner";
import StepTab from "./StepTab";
import CurrencyConverter from "./CurrencyConverter";

function CheckoutDetails({ handleNext, tabClass, activeTab }) {
  const [country, setCountry] = useState(null);
  const [state, setState] = useState(null);

  let bookingData;
  let userOrder;
  let userGuestBillingData;
  let userLogin;
  let userSignup;
  let placeOrderResult;
  if (typeof window !== "undefined" && window.sessionStorage) {
    bookingData = JSON.parse(sessionStorage.getItem("userBookingDetail"));
    userOrder = JSON.parse(sessionStorage.getItem("userOrderSummary"));
    userGuestBillingData = JSON.parse(
      sessionStorage.getItem("userGuestBillingData"),
    );
    userLogin = JSON.parse(sessionStorage.getItem("userLogin"));
    userSignup = JSON.parse(sessionStorage.getItem("userSignup"));
    placeOrderResult = JSON.parse(sessionStorage.getItem("PlaceOrderResult"));
  }

  // console.log(
  //   bookingData,
  //   userOrder,
  //   userGuestBillingData,
  //   userLogin,
  //   userSignup
  // );

  const isArrival = bookingData?.type?.toLowerCase() === "arrival";
  const isDeparture = bookingData?.type?.toLowerCase() === "departure";
  const istransit = bookingData?.type?.toLowerCase() === "transit";

  const commonCheckoutData = {
    serviceDate: isDeparture
      ? `${bookingData?.dateOfDeparture?.split("T")[0]} ${bookingData?.std}`
      : `${bookingData?.dateOfArrival?.split("T")[0]} ${bookingData?.sta}`,
    serviceType: bookingData?.type,
    serviceAirport: "Indira Gandhi International Airport",
    travelSector: bookingData?.sector,

    travelDate:
      bookingData?.type === "Arrival"
        ? bookingData?.dateOfArrival?.split("T")[0]
        : bookingData?.dateOfDeparture?.split("T")[0],

    numberOfGuests: `${bookingData?.adults} Adults | ${bookingData?.child} Child | ${bookingData?.infant} Infant`,

    customerName:
      userLogin?.user?.name ||
      `${userSignup?.firstName || ""} ${userSignup?.lastName || ""}`.trim(),

    mobileNumber: userLogin?.user?.mobile || userSignup?.mobile || "",

    placardName: `${
      userGuestBillingData?.billingFormData?.placard?.firstName || ""
    } ${userGuestBillingData?.billingFormData?.placard?.lastName || ""}`.trim(),

    placardMobile: userGuestBillingData?.billingFormData?.placard?.mobile || "",
  };

  let checkoutData = {};

  if (isArrival) {
    checkoutData = {
      ...commonCheckoutData,

      arrivalAirline: bookingData?.flight?.airline_id?.[1],
      fromAirport: bookingData?.originAirportName,
      toAirport: "Indira Gandhi International Airport",
      arrivalFlightNo: bookingData?.flight?.flight_name,
      arrivalTime: bookingData?.sta,
    };
  } else if (isDeparture) {
    checkoutData = {
      ...commonCheckoutData,

      arrivalAirline: bookingData?.flight?.airline_id?.[1],
      fromAirport: "Indira Gandhi International Airport",
      toAirport: bookingData?.destinationAirportName,
      arrivalFlightNo: bookingData?.flight?.flight_name,
      arrivalTime: bookingData?.sta,
    };
  } else {
    checkoutData = {
      ...commonCheckoutData,

      arrivalAirline: bookingData?.flight?.airline_id?.[1],
      departureAirline: bookingData?.flight2?.airline_id?.[1],

      fromAirport: bookingData?.originAirportName,
      toAirport: bookingData?.destinationAirportName,

      arrivalFlightNo: bookingData?.flight?.flight_name,
      arrivalTime: bookingData?.sta,

      departureFlightNo: bookingData?.flight2?.flight_name,
      departureTime: bookingData?.std,
    };
  }

  const DetailRow = ({ label, value }) => (
    <div className="flex justify-between items-center w-full mb-[0.8vw]">
      <p className="font-redhatRegular text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw] text-primary w-[40%]">
        {label}
      </p>
      <p className="font-redhatRegular text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw] text-primary w-[60%] text-right">
        {value}
      </p>
    </div>
  );

  const capitalizeFirstLetter = (str = "") =>
    str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <div>
      <CurrencyConverter totalAmount={userOrder?.totalAmount} />
      <div className="w-full px-[7vw] mt-[2vw] font-redhatRegular text-[#002C5F]">
        <StepTab tabClass={tabClass} activeTab={activeTab} />
      </div>
      <div className="flex flex-col xl:flex-row justify-between gap-[5vw] px-[7vw] py-[3vw]">
        {/* Left Checkout Details */}
        <div className="w-full xl:w-[65%]">
          {/* Checkout Section */}
          <h2 className="font-redhatBold text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw] text-primary mb-[1.2vw]">
            Checkout Details
          </h2>
          <div className="mb-[2.5vw]">
            {placeOrderResult && (
              <div>
                <DetailRow
                  label="Booking No:"
                  value={placeOrderResult?.bookingNumber}
                />
                <DetailRow
                  label="Booking Date:"
                  value={placeOrderResult?.bookingDate}
                />
                <DetailRow
                  label="Booking Time:"
                  value={placeOrderResult?.bookingTime}
                />
              </div>
            )}
            <DetailRow
              label="Service Date & Time:"
              value={checkoutData?.serviceDate}
            />
            <DetailRow
              label="Service Type:"
              value={checkoutData?.serviceType}
            />
            <DetailRow
              label="Service Airport:"
              value={checkoutData?.serviceAirport}
            />
            <DetailRow
              label="Travel Sector:"
              value={checkoutData?.travelSector}
            />
            <DetailRow label="Travel Date:" value={checkoutData.travelDate} />
            <DetailRow
              label={isDeparture ? "Departure Airline:" : "Arrival Airline:"}
              value={checkoutData?.arrivalAirline}
            />
            {istransit && (
              <DetailRow
                label="Departure Airline:"
                value={checkoutData?.departureAirline}
              />
            )}
            <DetailRow
              label="From Airport:"
              value={checkoutData?.fromAirport}
            />
            <DetailRow label="To Airport:" value={checkoutData?.toAirport} />
            <DetailRow
              label={
                isDeparture ? "Departure Flight No:" : "Arrival Flight No:"
              }
              value={checkoutData?.arrivalFlightNo}
            />
            <DetailRow
              label={isDeparture ? "Departure Time:" : "Arrival Time:"}
              value={checkoutData?.arrivalTime}
            />

            {istransit && (
              <DetailRow
                label="Departure Flight No:"
                value={checkoutData?.departureFlightNo}
              />
            )}
            {istransit && (
              <DetailRow
                label="Departure Time:"
                value={checkoutData?.departureTime}
              />
            )}
            <DetailRow
              label="Number of Guests:"
              value={checkoutData?.numberOfGuests}
            />
            <DetailRow
              label="Customer Name:"
              value={checkoutData?.customerName}
            />
            <DetailRow
              label="Mobile Number:"
              value={checkoutData?.mobileNumber}
            />
          </div>

          {/* Guest Details Section */}
          <h2 className="font-redhatBold text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw] text-primary mb-[1.2vw]">
            Guest Details
          </h2>
          {userGuestBillingData?.guest.map((guest, index) => {
            return (
              <div
                className="mb-[2.5vw] border-b border-primary pb-[2vw]"
                key={index}
              >
                <DetailRow
                  label="Name:"
                  value={`${guest?.first_name} ${guest?.last_name}`}
                />
                <DetailRow label="Age:" value={guest?.age} />
                <DetailRow label="Travel Class:" value={guest?.travelClass} />
                <DetailRow label="PNR No:" value={guest?.pnr} />
                <DetailRow
                  label="Passport / Govt ID:"
                  value={guest?.passport}
                />
              </div>
            );
          })}

          {/* Child Details */}
          {userGuestBillingData?.child &&
            userGuestBillingData?.child.length > 0 && (
              <div>
                <h2 className="font-redhatBold text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw] text-primary mb-[1.2vw]">
                  Child Details
                </h2>
                {userGuestBillingData.child.map((guest, index) => {
                  return (
                    <div
                      className="mb-[2.5vw] border-b border-primary pb-[2vw]"
                      key={index}
                    >
                      <DetailRow
                        label="Name:"
                        value={`${guest?.first_name} ${guest?.last_name}`}
                      />
                      <DetailRow label="Age:" value={guest?.age} />
                      <DetailRow
                        label="Travel Class:"
                        value={guest?.travelClass}
                      />
                      <DetailRow label="PNR No:" value={guest?.pnr} />
                      <DetailRow
                        label="Passport / Govt ID:"
                        value={guest?.passport}
                      />
                    </div>
                  );
                })}
              </div>
            )}

          {userGuestBillingData?.infant &&
            userGuestBillingData?.infant.length > 0 && (
              <div>
                <h2 className="font-redhatBold text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw] text-primary mb-[1.2vw]">
                  Child Details
                </h2>
                {userGuestBillingData.infant.map((guest, index) => {
                  return (
                    <div
                      className="mb-[2.5vw] border-b border-primary pb-[2vw]"
                      key={index}
                    >
                      <DetailRow
                        label="Name:"
                        value={`${guest?.first_name} ${guest?.last_name}`}
                      />
                      <DetailRow label="Age:" value={guest?.age} />
                      <DetailRow
                        label="Travel Class:"
                        value={guest?.travelClass}
                      />
                      <DetailRow label="PNR No:" value={guest?.pnr} />
                      <DetailRow
                        label="Passport / Govt ID:"
                        value={guest?.passport}
                      />
                    </div>
                  );
                })}
              </div>
            )}

          {/* Billing Details Section */}
          <div className="border-b border-primary mb-[2vw] md:mb-[1vw]">
            <h2 className="font-redhatBold  text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw] text-primary mb-[1.2vw]">
              Billing Details
            </h2>
            <div>
              {Object.entries(
                userGuestBillingData?.billingFormData?.billing,
              ).map(([key, value]) => {
                if (!value) return null; // skip empty values
                if (key === "country") {
                  return;
                }
                if (key === "state") {
                  return;
                }
                return (
                  <DetailRow
                    key={key}
                    label={`${capitalizeFirstLetter(key)}:`}
                    value={String(value)}
                  />
                );
              })}
            </div>
          </div>

          {/* Placard Details Section */}
          <h2 className="font-redhatBold text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw] text-primary mb-[1.2vw]">
            Placard Details
          </h2>
          <div>
            <DetailRow
              label="Placard Name:"
              value={checkoutData?.placardName}
            />
            <DetailRow label="Mobile No:" value={checkoutData?.placardMobile} />
          </div>
        </div>

        {/* Right Order Summary Placeholder */}
        <div className="w-full xl:w-[35%]">
          <OrderSummary
            data={userOrder?.product}
            addonCart={userOrder?.addon}
            bookingData={bookingData}
            nextStep={`Payment`}
            handleNext={handleNext}
          />
        </div>
      </div>
    </div>
  );
}

export default CheckoutDetails;
